
import _ from 'lodash';

export default {
  name: 'AppFilterSectionUserPropertyDropdownMenu',
  props: {
    title: { type: String, default: null },
    description: { type: String, default: null },
    options: { type: Array, required: true },
    value: { type: Object, default: null },
    maxHeight: { type: Number, default: null }
  },
  data() {
    return {
      currentValue: _.cloneDeep(this.value),
      isEditing: false
    };
  },
  computed: {
    maxHeightProps() {
      const maxHeight = this.maxHeight || 480;
      const headHeight = 82;
      const footHeight = 79;
      const padding = 15;

      return {
        '--max-height': `${maxHeight - headHeight - footHeight - padding}px`
      };
    },
    isCurrentValueAllBlank() {
      return Object.values(this.currentValue).every(v => !v);
    },
    userPropertyStr() {
      return this.options
        .map(option => {
          if (this.value[option.key]) {
            return `${option.name} ${this.value[option.key]}${option.unit}`;
          }
        })
        .filter(Boolean)
        .join(', ');
    }
  },
  created() {
    if (this.isCurrentValueAllBlank) {
      this.isEditing = true;
    }
    this.originalValue = { ...this.value };
  },
  methods: {
    onClickEditButton() {
      this.isEditing = true;
    },
    onChangeInputValue(key, newValue) {
      this.$set(this.currentValue, key, newValue);
    },
    cancel() {
      const { height, weight } = this.originalValue;
      if (!(height || weight)) {
        this.$emit('close');
      } else {
        this.currentValue = { ...this.originalValue };
        this.isEditing = false;
      }
    },
    save() {
      if (!_.isEqual(this.value || {}, this.currentValue)) {
        this.$emit('save', this.currentValue);
        this.originalValue = { ...this.currentValue };
      }
      this.isEditing = false;
    },
    apply() {
      this.$emit('apply');
      this.$emit('close');
    },
    reset() {
      this.$emit('reset');
      this.$emit('close');
    }
  }
};
